import { render, staticRenderFns } from "./InactiveLink.vue?vue&type=template&id=784aaa49&"
import script from "./InactiveLink.vue?vue&type=script&lang=js&"
export * from "./InactiveLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports